import React from 'react'
import './Heading.css'

const Heading = props => {
  const classNames = ['Heading']

  if(props.gray) classNames.push('is-gray')

  return (
    <div className={classNames.join(' ')} style={props.divStyle}>
      {props.h1 && !props.html && <h1 style={props.style}>{props.children}</h1>}
      {props.h2 && !props.html && <h2 style={props.style}>{props.children}</h2>}
      {props.h3 && !props.html && <h3 style={props.style}>{props.children}</h3>}
      {props.h4 && !props.html && <h4 style={props.style}>{props.children}</h4>}
      {props.h5 && !props.html && <h5 style={props.style}>{props.children}</h5>}
      {props.h6 && !props.html && <h6 style={props.style}>{props.children}</h6>}
      {props.em && !props.html && <em style={props.style}>{props.children}</em>}

      {props.h1 && props.html && <h1 style={props.style} dangerouslySetInnerHTML={{ __html: props.children }}></h1>}
      {props.h2 && props.html && <h2 style={props.style} dangerouslySetInnerHTML={{ __html: props.children }}></h2>}
      {props.h3 && props.html && <h3 style={props.style} dangerouslySetInnerHTML={{ __html: props.children }}></h3>}
      {props.h4 && props.html && <h4 style={props.style} dangerouslySetInnerHTML={{ __html: props.children }}></h4>}
      {props.h5 && props.html && <h5 style={props.style} dangerouslySetInnerHTML={{ __html: props.children }}></h5>}
      {props.h6 && props.html && <h6 style={props.style} dangerouslySetInnerHTML={{ __html: props.children }}></h6>}
      {props.em && props.html && <em style={props.style} dangerouslySetInnerHTML={{ __html: props.children }}></em>}
    </div>
  )
}

export default Heading
